// Concentration Molar units with conversion factors to mole per liter (mol/L)
export const concentrationMolarUnits = [
  { id: 'mole-per-liter', name: 'Mole per Liter', symbol: 'mol/L', plural: 'Moles per Liter', factor: 1 },
  { id: 'mole-per-cubic-meter', name: 'Mole per Cubic Meter', symbol: 'mol/m³', plural: 'Moles per Cubic Meter', factor: 0.001 },
  { id: 'millimole-per-liter', name: 'Millimole per Liter', symbol: 'mmol/L', plural: 'Millimoles per Liter', factor: 0.001 },
  { id: 'micromole-per-liter', name: 'Micromole per Liter', symbol: 'µmol/L', plural: 'Micromoles per Liter', factor: 1e-6 },
  { id: 'nanomole-per-liter', name: 'Nanomole per Liter', symbol: 'nmol/L', plural: 'Nanomoles per Liter', factor: 1e-9 },
  { id: 'picomole-per-liter', name: 'Picomole per Liter', symbol: 'pmol/L', plural: 'Picomoles per Liter', factor: 1e-12 },
  { id: 'mole-per-cubic-centimeter', name: 'Mole per Cubic Centimeter', symbol: 'mol/cm³', plural: 'Moles per Cubic Centimeter', factor: 1000 },
  { id: 'mole-per-cubic-millimeter', name: 'Mole per Cubic Millimeter', symbol: 'mol/mm³', plural: 'Moles per Cubic Millimeter', factor: 1000000 },
  { id: 'kilomole-per-liter', name: 'Kilomole per Liter', symbol: 'kmol/L', plural: 'Kilomoles per Liter', factor: 1000 },
  { id: 'kilomole-per-cubic-meter', name: 'Kilomole per Cubic Meter', symbol: 'kmol/m³', plural: 'Kilomoles per Cubic Meter', factor: 1 },
];

export const popularConcentrationMolarConversions = [
  { from: 'mole-per-liter', to: 'millimole-per-liter' },
  { from: 'millimole-per-liter', to: 'mole-per-liter' },
  { from: 'mole-per-liter', to: 'micromole-per-liter' },
  { from: 'micromole-per-liter', to: 'nanomole-per-liter' },
  { from: 'mole-per-liter', to: 'mole-per-cubic-meter' },
  { from: 'kilomole-per-liter', to: 'mole-per-liter' },
];

export const getUnitById = (id) => concentrationMolarUnits.find(unit => unit.id === id);

export const convertConcentrationMolar = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert molar concentration units and learn the conversion formula.`;
};
